import { useTranslation } from 'react-i18next';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface ListHeaderProps extends BoxProps {
  headerTitles: string[];
  gridTemplateColumns: string;
}

export const ListHeader = ({
  headerTitles,
  gridTemplateColumns,
  ...restProps
}: ListHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        flexShrink: 0,
        position: 'sticky',
        top: 0,
        height: '48px',
        backgroundColor: (theme) => theme.palette.background.paper,
        zIndex: 999,
      }}
      {...restProps}
    >
      <Box
        sx={{
          height: '100%',
          display: 'grid',
          gridTemplateColumns,
          alignItems: 'center',
          justifyItems: 'flex-start',
          px: '20px',
          gap: 2,
          backgroundColor: '#EAEAEA',
          borderBottom: `1px solid #0000001F`,
        }}
      >
        {headerTitles.map((title, index) => (
          <Typography
            variant={'subtitle2'}
            color={(theme) => theme.palette.text.secondary}
            key={index}
          >
            {t(title)}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
